export class Constants
{
    public static welt: number = 24;
    public static spacing: number = 4;
    public static weekStartsOn: 0 | 1 | 2 | 3 | 4 | 5 | 6 = 1;
    public static weekdays: 6 | 7;
}
